/*
 *
 * MsDynamicsVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/MsDynamicsVerify';

export const VERIFY_MS_DYNAMICS = defineApiActionTypes(`${prefix}/VERIFY_MS_DYNAMICS_START`);
